export default {"src":"/_next/static/media/test-logo.e53a5f57.svg","height":58,"width":58,"blurWidth":0,"blurHeight":0};